import React from 'react';

const ProjectAlertModal = ({
    show,
    onHide,
    type = 'success', // 'success' or 'error'
    title,
    message = ''
}) => {

    const isSuccess = type === 'success';
    const defaultTitle = isSuccess ? 'Sucesso!' : 'Erro!';
    const displayTitle = title || defaultTitle;

    if (!show) return null;

    return (
        <>
            {/* Modern Alert Notification */}
            <div
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 10000,
                    minWidth: '320px',
                    maxWidth: '420px',
                    background: isSuccess ? '#003B6B' : '#dc3545',
                    color: 'white',
                    padding: '16px 20px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px',
                    animation: 'slideInRight 0.3s ease-out'
                }}
            >
                <div style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    marginTop: '2px'
                }}>
                    {/* {isSuccess ? '✓' : '✕'} */}
                </div>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '700', marginBottom: '0.25rem' }}>
                        {displayTitle}
                    </div>
                    <div style={{ opacity: 0.9, fontSize: '0.9rem', lineHeight: '1.4' }}>
                        {message}
                    </div>
                </div>
                <button
                    onClick={onHide}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: 'white',
                        fontSize: '18px',
                        cursor: 'pointer',
                        padding: '0',
                        flexShrink: 0,
                        opacity: 0.7,
                        lineHeight: 1
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '1'}
                    onMouseOut={(e) => e.target.style.opacity = '0.7'}
                    title="Fechar notificação"
                >
                    ×
                </button>
            </div>

            <style>
                {`
                    @keyframes slideInRight {
                        from {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }
                `}
            </style>
        </>
    );
};

export default ProjectAlertModal;